import React from 'react';
import { Link } from 'react-router-dom';
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'

const DependingObjects = (props) => {
    const list = props.list
    const returnUrl = props.returnUrl
    const size = props.size || ''
    
    if( !list || list.length == 0 ) {
        return null
    }
    const queryString = typeof returnUrl === 'undefined' || returnUrl == '' ? '' : '?returnUrl=' + returnUrl
    
    return (
        <DropdownButton as={ButtonGroup} key="down" title="In-Use" variant="danger" size={size}>
            {list.map(function(obj) {
                return (
                    <Dropdown.Item key={obj.href}>
                        <Link className="dropdown-item" to={`${obj.href}${queryString}`}>
                            {obj.type}: {obj.display_name}
                        </Link>
                    </Dropdown.Item>
                )
            })}
        </DropdownButton>
    )
}

export default DependingObjects
